<template>
	<svg
		class="car-broken-svg-container"
		version="1.0"
		xmlns="http://www.w3.org/2000/svg"
		width="300.000000pt"
		height="300.000000pt"
		viewBox="0 0 300.000000 300.000000"
		preserveAspectRatio="xMidYMid meet"
	>
		<g
			transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
			fill="#000000"
			stroke="none"
		>
			<path
				class="main-color"
				d="M2723 2846 c-136 -64 -151 -243 -26 -330 80 -55 175 -43 245 31 34
  36 48 73 48 129 0 85 -47 150 -129 179 -58 20 -77 19 -138 -9z m145 -30 c48
  -30 66 -52 86 -101 16 -37 16 -43 1 -82 -16 -43 -67 -95 -112 -116 -46 -21
  -107 49 -123 140 -7 43 -8 44 -9 13 0 -19 8 -55 19 -79 27 -58 25 -65 -7 -46
  -69 41 -91 122 -54 198 17 36 53 67 77 67 2 0 -3 -16 -11 -36 -23 -55 -18 -65
  7 -15 16 34 66 81 86 81 1 0 19 -11 40 -24z"
			/>
			<path
				class="main-color"
				d="M2331 2534 c-86 -72 -47 -197 66 -210 80 -10 147 70 124 147 -16 54
  -62 89 -116 89 -32 0 -51 -7 -74 -26z m125 -29 c33 -31 36 -39 31 -71 -6 -37
  -34 -68 -69 -80 -25 -7 -64 27 -71 63 -7 37 10 90 36 108 29 20 30 20 73 -20z"
			/>
			<path
				class="main-color"
				d="M2685 2215 c-5 -2 -28 -9 -51 -14 -51 -14 -128 -80 -156 -135 -26
  -51 -35 -169 -16 -206 13 -24 12 -27 -25 -53 -100 -73 -102 -245 -3 -321 131
  -100 326 -11 330 151 1 41 3 43 44 57 149 51 221 231 149 372 -29 58 -72 98
  -134 126 -41 18 -119 31 -138 23z m150 -66 c117 -79 148 -206 80 -323 -25 -42
  -78 -86 -121 -100 -34 -11 -53 -39 -64 -96 -12 -63 -45 -111 -93 -134 -41 -19
  -122 -21 -157 -3 -36 17 -61 77 -61 141 0 60 15 98 55 135 14 14 26 33 26 43
  0 10 5 18 11 18 7 0 9 -9 5 -24 -4 -16 1 -32 15 -50 28 -36 34 -27 14 20 -22
  53 -29 141 -16 190 23 84 94 160 186 197 56 22 68 21 120 -14z m-213 -25 c-68
  -60 -100 -115 -108 -189 -8 -67 -22 -52 -23 25 -1 76 51 156 124 190 62 30 64
  23 7 -26z"
			/>
			<path
				class="main-color"
				d="M2276 2078 c-86 -99 -154 -257 -181 -423 -23 -137 -20 -200 11 -266
  32 -67 51 -77 171 -89 129 -14 159 -19 232 -35 101 -24 254 -74 285 -95 l28
  -18 -61 -22 c-146 -53 -194 -202 -97 -301 37 -38 119 -79 161 -79 62 -1 75 -9
  75 -51 l0 -39 -217 0 c-119 0 -214 -2 -212 -4 2 -2 94 -6 204 -9 110 -4 201
  -6 203 -7 6 -1 1 -47 -10 -77 l-12 -33 -151 0 c-185 0 -195 -4 -195 -85 0 -76
  -31 -152 -82 -202 -59 -56 -101 -75 -179 -81 -57 -4 -75 -1 -128 23 -94 43
  -149 117 -165 227 -8 52 -17 63 -61 73 -17 4 -45 16 -62 27 -31 18 -55 20
  -401 21 -357 1 -370 0 -398 -20 -16 -11 -48 -24 -72 -28 -43 -7 -62 -26 -62
  -63 0 -41 -34 -123 -67 -162 -51 -59 -109 -89 -185 -97 -167 -15 -294 99 -306
  275 -6 87 -12 92 -125 92 -108 0 -114 3 -125 64 -5 29 -5 56 0 63 5 6 31 14
  58 18 27 4 66 15 86 26 42 21 39 22 54 -11 8 -20 9 -15 4 27 -4 39 -2 58 10
  75 32 45 16 143 -30 186 -27 26 -29 46 -12 106 9 31 33 62 96 124 l85 82 767
  0 c800 0 790 -1 790 42 0 22 -223 471 -256 514 -13 18 -47 44 -76 58 l-52 26
  -460 -2 -461 -3 465 -5 465 -5 47 -28 c59 -34 67 -47 168 -247 45 -91 98 -195
  116 -231 58 -114 126 -104 -728 -106 -403 -1 -744 -2 -759 -2 -29 -1 -144 -91
  -179 -141 -12 -17 -30 -53 -40 -78 -13 -36 -21 -46 -36 -44 -10 2 -56 6 -101
  9 -46 3 -83 10 -83 14 0 22 53 89 102 130 108 89 148 131 153 163 7 48 13 92
  25 206 21 196 41 258 107 331 69 77 184 126 272 117 33 -3 34 -4 18 -20 -29
  -28 -19 -27 37 3 l55 30 353 -1 c194 0 378 -2 409 -4 87 -5 153 -32 212 -86
  52 -47 59 -59 115 -175 92 -189 172 -324 172 -288 0 6 -48 105 -106 221 -120
  239 -160 289 -269 333 -60 24 -60 24 -535 27 -541 4 -573 0 -677 -67 -108 -70
  -165 -168 -183 -316 -6 -49 -13 -106 -15 -125 -5 -37 -25 -204 -25 -206 0 0
  -44 -38 -99 -83 -101 -85 -134 -129 -146 -193 l-7 -36 99 -4 c92 -3 103 -5
  137 -32 67 -51 82 -120 44 -196 -32 -63 -90 -92 -175 -88 -52 2 -62 0 -59 -12
  3 -8 10 -55 16 -103 l12 -89 122 4 121 3 0 -80 c0 -70 4 -87 30 -133 98 -178
  331 -221 481 -89 59 52 104 142 104 210 l0 47 48 0 c36 0 50 5 60 20 12 20 21
  20 394 18 371 -3 383 -4 393 -23 8 -16 18 -19 51 -17 l41 3 6 -56 c11 -109 73
  -197 174 -247 57 -28 76 -32 137 -31 84 1 145 24 206 79 70 63 93 114 98 213
  l4 86 177 0 176 0 22 125 c12 69 22 130 22 135 1 6 -19 9 -48 7 -79 -6 -159
  22 -207 73 -53 55 -62 98 -35 160 24 54 89 99 167 115 73 15 109 6 124 -31 14
  -32 34 -51 23 -22 -32 90 -196 171 -468 229 -23 5 -138 23 -181 29 -16 2 -55
  4 -86 4 l-58 1 0 108 c0 246 81 494 195 602 41 38 29 90 -21 90 -15 0 -39 -19
  -68 -52z m64 -9 c0 -6 -19 -33 -41 -61 -80 -94 -155 -322 -163 -493 -2 -33 -4
  -70 -5 -82 -1 -16 -5 -21 -17 -16 -17 6 -17 14 10 203 25 180 77 311 165 419
  33 41 51 51 51 30z"
			/>
			<path
				class="main-color"
				d="M733 1869 c-39 -14 -43 -39 -43 -261 0 -280 -19 -258 218 -258 97 0
  187 3 199 6 37 10 44 56 41 278 -3 181 -5 207 -21 223 -16 16 -39 18 -195 19
  -97 1 -187 -2 -199 -7z m387 -256 l0 -233 -200 0 -200 0 0 234 0 234 200 -1
  200 -2 0 -232z"
			/>
			<path
				class="main-color"
				d="M1225 1870 c-43 -16 -46 -29 -46 -236 0 -110 1 -209 1 -221 0 -13 9
  -32 20 -43 19 -19 33 -20 344 -20 348 0 356 1 356 51 0 11 -41 102 -91 202
  -98 197 -137 248 -205 266 -44 12 -348 12 -379 1z m401 -43 c45 -23 55 -38
  161 -249 l99 -198 -338 0 -337 0 -3 231 c-2 127 -1 233 1 235 3 2 91 3 196 0
  145 -3 199 -8 221 -19z"
			/>
			<path
				class="main-color"
				d="M595 1853 c-34 -9 -86 -55 -106 -95 -12 -23 -27 -93 -39 -185 -24
  -182 -24 -179 0 -203 16 -16 33 -20 93 -20 39 0 77 4 83 8 29 19 34 56 34 260
  0 190 -2 210 -18 225 -10 10 -20 16 -23 16 -2 -1 -13 -4 -24 -6z m35 -243 l0
  -230 -85 0 c-63 0 -85 3 -85 13 0 7 9 84 20 171 21 174 33 205 97 249 21 14
  41 26 46 26 4 1 7 -102 7 -229z"
			/>
			<path
				class="main-color"
				d="M464 1184 c-30 -29 -27 -67 8 -96 31 -28 166 -25 202 3 32 25 35 70
  6 99 -17 17 -33 20 -105 20 -79 0 -88 -2 -111 -26z m204 -6 c19 -19 14 -55
  -10 -72 -35 -25 -152 -22 -178 4 -24 24 -25 43 -4 64 19 20 173 23 192 4z"
			/>
			<path
				class="main-color"
				d="M1210 1190 c-29 -29 -26 -74 6 -99 22 -17 41 -21 101 -21 69 0 77 2
  104 29 34 35 36 49 8 85 -19 25 -25 26 -110 26 -76 0 -92 -3 -109 -20z m204
  -19 c21 -23 14 -56 -13 -71 -10 -5 -53 -8 -95 -7 -81 3 -96 11 -96 53 0 36 20
  44 105 44 68 0 85 -3 99 -19z"
			/>
			<path
				class="main-color"
				d="M2814 1023 c-12 -2 -36 -16 -54 -32 -44 -36 -37 -72 19 -101 51 -26
  180 -33 182 -10 4 39 7 59 13 84 13 52 3 61 -71 62 -38 1 -77 0 -89 -3z m123
  -25 c14 -11 7 -86 -10 -106 -23 -28 -156 5 -170 42 -21 53 127 105 180 64z"
			/>
			<path
				class="main-color"
				d="M6 911 c3 -18 8 -41 9 -50 2 -9 4 -27 4 -41 1 -25 2 -25 73 -22 81 4
  108 19 108 61 -1 50 -19 61 -108 61 -55 0 -82 4 -86 13 -3 6 -3 -3 0 -22z
  m158 -17 c20 -19 21 -48 2 -63 -12 -10 -72 -17 -117 -12 -20 1 -34 71 -18 82
  23 14 117 9 133 -7z"
			/>
			<path
				class="main-color"
				d="M542 735 c-29 -8 -72 -28 -96 -44 -28 -19 -58 -31 -87 -33 l-44 -3
  43 -5 c35 -5 51 -1 80 19 117 80 251 80 362 1 42 -30 59 -24 19 6 -82 62 -186
  84 -277 59z"
			/>
			<path
				class="main-color"
				d="M2158 736 c-26 -7 -71 -27 -99 -44 l-50 -32 -576 0 c-317 0 -574 -2
  -571 -5 3 -3 263 -5 579 -5 l575 0 77 39 c71 38 82 40 150 38 65 -2 81 -7 137
  -40 34 -21 67 -36 71 -35 18 6 -93 71 -143 84 -63 17 -88 17 -150 0z"
			/>
			<path
				class="main-color"
				d="M555 624 c-123 -45 -172 -193 -98 -298 92 -130 286 -110 348 36 44
  107 -21 235 -136 268 -44 13 -65 12 -114 -6z m142 -19 c75 -31 109 -87 107
  -175 -4 -199 -272 -248 -355 -65 -70 153 89 306 248 240z"
			/>
			<path
				class="main-color"
				d="M554 561 c-99 -60 -102 -184 -7 -247 39 -25 115 -24 151 3 87 65 84
  190 -6 243 -42 25 -98 25 -138 1z m116 -26 c74 -38 82 -134 16 -187 -24 -20
  -83 -23 -119 -7 -51 23 -71 94 -42 149 28 54 90 73 145 45z"
			/>
			<path
				class="main-color"
				d="M2163 624 c-90 -33 -145 -134 -124 -228 14 -62 42 -100 97 -132 38
  -23 54 -26 107 -22 70 4 109 26 153 84 39 51 44 143 12 204 -46 85 -156 127
  -245 94z m182 -38 c44 -34 75 -95 75 -151 0 -62 -45 -135 -100 -162 -195 -98
  -373 151 -213 298 47 44 65 50 134 47 55 -3 73 -8 104 -32z"
			/>
			<path
				class="main-color"
				d="M2162 560 c-68 -42 -92 -130 -52 -195 54 -87 166 -95 232 -17 38 45
  44 94 18 147 -38 79 -127 108 -198 65z m151 -50 c39 -43 38 -106 -2 -149 -24
  -26 -37 -31 -74 -31 -84 0 -137 76 -106 151 30 74 128 89 182 29z"
			/>
			<path
				class="main-color"
				d="M88 413 c34 -2 90 -2 125 0 34 2 6 3 -63 3 -69 0 -97 -1 -62 -3z"
			/>
			<path
				class="main-color"
				d="M1253 413 c104 -2 270 -2 370 0 100 1 16 2 -188 2 -203 0 -285 -1
  -182 -2z"
			/>
			<path
				class="main-color"
				d="M2673 413 c54 -2 139 -2 190 0 51 1 7 3 -98 3 -104 0 -146 -2 -92 -3z"
			/>
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'CarBrokenSVG',
	};
</script>

<style scoped>
	.car-broken-svg-container {
		width: 100%;
		height: 100%;
	}

	.main-color {
		fill: #61cc98;
	}
</style>
